var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isReady)?_c('div',{staticClass:"waitingIcon"},[_c('icon',{staticClass:"iconClass",attrs:{"name":"spinner","scale":"2","spin":""}})],1):_vm._e(),_vm._v(" "),(_vm.isReady)?_c('div',{attrs:{"id":"appFrame"}},[_c('navigation'),_vm._v(" "),_c('router-view')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3476f1b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPage.vue
// module id = null
// module chunks = 